import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)({
  position: "absolute",
  color: "#335c67",
  fontSize: 18,
  fontWeight: 700,
});

export default StyledButton;
